import { Injectable, signal } from '@angular/core';
import { FeatureFlagConfigData } from './feature-flag-config.interface';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  readonly configData = signal<FeatureFlagConfigData>({
    erfassungBehandlerGutachtenEnabled: false,
    ctAuftragZuordnungEnabled: false,
    psBackendWeiterleitungEnabled: false,
    gutachterPanelEnabled: false,
  });
}
